// extracted by mini-css-extract-plugin
export default {"mainDiv":"types_mainDiv__Q4axy"};